import type { ErrorCode } from './protocol.ts'
import type { Theme } from './theme.ts'

export const ACTION_LIST = 'payment_method.select'
export const ACTION_CARD_CREATE = 'payment_method.card.create'
export const ACTION_SELECT = 'payment_method.select'
export const ACTION_PAYMENT_CREATE = 'payment.create'

/** Submitted attempts one terminal session allows. */
export const MAX_PAYMENT_ATTEMPTS = 3

export interface PaymentMethodSummary {
  paymentMethodId: number
  paymentType: 'card' | 'ach'
  brand: string | null
  last4: string
  expMonth: number | null
  expYear: number | null
}

export interface SessionConfig {
  actions: string[]
  actionId: string
  sessionExpiresAt: string
  theme: Theme
  locale: string
}

export interface TokenizedCard {
  cardAlias: string
  cvvAlias: string
  brand: string | null
  last4: string
  expMonth: number
  expYear: number
}

export interface CardDraft extends TokenizedCard {
  nameOnCard: string
}

export interface TerminalError {
  code: ErrorCode
  message: string
}

export interface CardSummary {
  brand: string | null
  last4: string
}

export interface PaymentQuote {
  attemptId: number
  amount: number
  fee: number
  total: number
  currency: string
  method: CardSummary
}

export type PaymentStatus = 'paid' | 'pending'

export interface PaymentRecord {
  paymentId: number
  status: PaymentStatus
  amount: number
  fee: number
  total: number
  currency: string
  method: CardSummary
}

export interface PaymentDecline {
  reason: string
  attemptsRemaining: number
}

export type SubmitOutcome =
  | { kind: 'succeeded'; payment: PaymentRecord }
  | { kind: 'declined'; decline: PaymentDecline }
  | { kind: 'unknown' }

export type AttemptState =
  | { status: 'pending' | 'submitted' | 'unknown' }
  | { status: 'succeeded'; payment: PaymentRecord }
  | { status: 'declined'; decline: PaymentDecline }

export interface MethodResult {
  action: typeof ACTION_SELECT | typeof ACTION_CARD_CREATE
  actionId: string
  paymentMethodId: number
  paymentType: PaymentMethodSummary['paymentType']
  brand: string | null
  last4: string
  expMonth: number | null
  expYear: number | null
  status: 'selected' | 'created'
}

export interface PaymentResult {
  action: typeof ACTION_PAYMENT_CREATE
  actionId: string
  paymentId: number
  status: PaymentStatus
  amount: number
  fee: number
  total: number
  currency: string
  brand: string | null
  last4: string
}

export type SuccessResult = MethodResult | PaymentResult
